import { destroyCartUuidCookie, setCartUuidToCookies } from 'helpers/cookies/cartUuidCookieHelper';
import { destroyDefaultStoreUuidCookie, setDefaultStoreUuidToCookies } from 'helpers/cookies/defaultStoreCookieHelper';
import { isClient } from 'helpers/isServer';
import { AddToCartData } from 'types/cart';
import { PaymentStatusType } from 'types/paymentStatus';
import { StateCreator } from 'zustand';

type UserEntryType = 'login' | 'registration';

export type UserSlice = {
    canAccessOrderConfirmation: boolean;
    paymentStatus: PaymentStatusType | null;
    lastOrderUuid: string | null;
    lastOrderPaymentType: string | null;
    urlHash: string | undefined;
    lastOrderNumber: string | null;
    userUuid: string | null;
    userEmail: string | null;
    loyaltyClubPoints: number | null;
    loyaltyClubPointsMaximum: number | null;
    cartUuid: string | null;
    wishlistUuid: string | null;
    selectedDeliveryAddressUuid: string | null;
    defaultStoreUuid: string | null;
    selectedStoreUuid: string | null;
    addToCartPopupData: AddToCartData | null;
    addToCartFetching: boolean;
    cashOnDeliveryDisabled: boolean;
    userEntry: UserEntryType | null;

    updateUserState: (value: Partial<Omit<UserSlice, 'defaultStoreUuid'>>) => void;
    updateCartUuid: (value: Partial<string | null>) => void;
    updateWishlistUuid: (value: Partial<string | null>) => void;
    updateDefaultStoreUuidState: (value: Partial<string | null>) => void;
    updateSelectedAndDefaultStoreUuidState: (value: string | null) => void;
    updateUserEntryState: (value: UserEntryType | null) => void;
};

export const createUserSlice: StateCreator<UserSlice> = (set) => ({
    canAccessOrderConfirmation: false,
    paymentStatus: null,
    urlHash: undefined,
    lastOrderNumber: null,
    userUuid: null,
    userEmail: null,
    loyaltyClubPoints: null,
    loyaltyClubPointsMaximum: null,
    cartUuid: null,
    wishlistUuid: null,
    selectedDeliveryAddressUuid: null,
    defaultStoreUuid: null,
    selectedStoreUuid: null,
    lastOrderPaymentType: null,
    lastOrderUuid: null,
    addToCartPopupData: null,
    addToCartFetching: false,
    cashOnDeliveryDisabled: false,
    userEntry: null,

    updateUserState: (value) => {
        set(value);
    },

    updateCartUuid: (value) => {
        if (isClient) {
            if (value) {
                setCartUuidToCookies(value);
            } else {
                destroyCartUuidCookie();
            }

            set({ cartUuid: value });
        }
    },

    updateWishlistUuid: (wishlistUuid) => {
        set({ wishlistUuid });
    },

    updateDefaultStoreUuidState: (value) => {
        if (isClient) {
            if (value) {
                setDefaultStoreUuidToCookies(value);
            } else {
                destroyDefaultStoreUuidCookie();
            }

            set({ defaultStoreUuid: value });
        }
    },

    updateSelectedAndDefaultStoreUuidState: (value) => {
        if (isClient) {
            if (value) {
                setDefaultStoreUuidToCookies(value);
            } else {
                destroyDefaultStoreUuidCookie();
            }

            set({ defaultStoreUuid: value, selectedStoreUuid: value });
        }
    },

    updateUserEntryState: (value) => {
        set({ userEntry: value });
    },
});
